// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"2771a5bf","452":"9bbfa34d","787":"03b918b1"}[chunkId] + ".chunk.js";
};